import Meta from '@/components/common/Meta'

import StorageFacilitiesThatShipPage from '@/v2/components/pages/landing-pages/storage-facilities-that-ship-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/landing-pages/storage-facilities-that-ship-page'

interface StorageFacilitiesThatShipPageProps {}

const Page: React.FC<StorageFacilitiesThatShipPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.storage_facilities_that_ship.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_facilities_that_ship?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_facilities_that_ship?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <StorageFacilitiesThatShipPage />
    </>
  )
}

export default Page
